import React, { useContext, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, LinearProgress } from '@material-ui/core';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { PatientIntakeContext } from '../contexts/PatientIntakeContext';
import ValidationPage from './ValidationPage';
import StepperComponent from './Stepper';
import InsurancePage from './InsurancePage';
import { getExpiryStatus } from 'api/patientIntakeApi';
import { useTranslation } from 'react-i18next';

const PatientIntakePage = ({ match }) => {
    const [loading, setLoading] = useState(false);
    const [isVisitValid, setIsVisitValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const intake = useContext(PatientIntakeContext);
    const secureId = match?.params?.secureId;
    const [t] = useTranslation();

    const useStyles = makeStyles(() => ({
        container: {
            paddingInline: "10px",
            justifyContent:"center",
            alignItems:"center"
        }
    }));
    const classes = useStyles();

    const fetchExpirtStatus = async () => {
        try {
            setLoading(true);
            const data = await getExpiryStatus(secureId);
            setIsVisitValid(data?.success);
            if (!data?.success) {
                setErrorMessage(data?.message)
            }else{
                intake.setScheduleId(data?.scheduleId);
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        intake.setSecureId(secureId);
        fetchExpirtStatus();
    }, [secureId]);

    if (loading) return <LinearProgress />;

    return (

        <Grid container className={classes.container} >
            {errorMessage && (
                <Alert severity="error">
                    <b>{t(errorMessage)}</b>
                </Alert>
            )}
            {!errorMessage && isVisitValid && <Grid item xs={12} sm={6}  >
                {intake?.page !== 4 && (
                    <StepperComponent />
                )}
                {intake?.page === 0 && <ValidationPage />}
                {intake?.page === 1 && <InsurancePage />}
                {intake?.page === 2 && <div>Payment Screen</div>}
                {intake?.page === 4 && <ValidationPage />}
               
            </Grid>}
        </Grid>
    );
};

PatientIntakePage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            secureId: PropTypes.string,
        }),
    }).isRequired,
};

export default PatientIntakePage;
